<script setup lang="ts">
import Button, { type ButtonProps } from './Button.vue'

interface Props extends ButtonProps {
  lighting?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  lighting: false
})

</script>

<template>
  <div v-if="props.lighting" class="rounded-full relative">
    <div 
      :class="[
        'bg-effect-lighting bg-brand-gradient opacity-70 -z-5',
        'absolute left-1/2  -translate-x-1/2 top-1/2 -translate-y-1/2',
        'aspect-video w-[175%]',
      ]" 
    />
    <Button
        :as="props.as"
        :href="props.href"
        :icon="props.icon"
        :size="props.size"
    >
      <slot />
    </Button>
  </div>
  <Button 
    v-else 
    :as="props.as"
    :href="props.href"
    :icon="props.icon"
    :size="props.size"
  >
    <slot />
  </Button>
</template>